export default __webpack_public_path__ + "static/media/aasya.84685a75.jpg";